import { IconProps } from '.';

const FacebookIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      className={customClasses}
      width="1em"
      height="1em"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M13.5 0C6.32036 0 0.5 5.82036 0.5 13C0.5 19.0965 4.69744 24.2122 10.3597 25.6173V16.9728H7.67912V13H10.3597V11.2882C10.3597 6.86348 12.3622 4.8126 16.7063 4.8126C17.53 4.8126 18.9512 4.97432 19.5325 5.13552V8.73652C19.2257 8.70428 18.6927 8.68816 18.0308 8.68816C15.8993 8.68816 15.0756 9.49572 15.0756 11.595V13H19.3219L18.5924 16.9728H15.0756V25.9048C21.5127 25.1274 26.5005 19.6466 26.5005 13C26.5 5.82036 20.6796 0 13.5 0Z"
        fill={color || 'var(--color-button-outline-tertiary)'}
      />
    </svg>
  );
};

export default FacebookIcon;
